import { createMuiTheme } from '@material-ui/core/styles';
import { ubuntuLight } from './importFonts';
import { makeStyles } from '@material-ui/core/styles';
export const themeLogin = createMuiTheme({
    palette: {
      primary: {
        // light: will be calculated from palette.primary.main,
        main: '#0097a0',
        // dark: will be calculated from palette.primary.main,
        // contrastText: will be calculated to contrast with palette.primary.main
      },
      secondary: {
        light: '#0066ff',
        main: '#444242',
        // dark: will be calculated from palette.secondary.main,
        contrastText: '#ffcc00',
      },
      titles: {
          main: '#FFFFFF'
      },
      // Used by `getContrastText()` to maximize the contrast between
      // the background and the text.
      contrastThreshold: 3,
      // Used by the functions below to shift a color's luminance by approximately
      // two indexes within its tonal palette.
      // E.g., shift from Red 500 to Red 300 or Red 700.
      tonalOffset: 0.2,
    },
    typography: {
      fontFamily: 'UbuntuLight',
    },
    overrides: {
      MuiCssBaseline: {
        '@global': {
          '@font-face': [ubuntuLight],
        },
      },
    },

  });

  export const buttonsStyles = makeStyles(theme => ({
    paper: {
      marginTop: 8,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
    },
    avatar: {
      margin: 1,
      backgroundColor: 'red',
    },
    form: {
      width: '100%', // Fix IE 11 issue.
      //marginTop: 1,
      background: "linear-gradient(to bottom, #f6f6f6, #f4f4f4, #f2f2f2, #f1f0f0, #efeeee, #ebeaea, #e8e6e6, #e4e2e2, #dddbdb, #d6d5d5, #d0cece, #c9c8c8);",
      padding: "1% 6% 6% 6%",
      borderRadius: "5px",
      border: "3px solid #E4E4E4"
    },
    submit: {
      margin: theme.spacing(1),
      fontWeight: 'bold',
      fontSize: '0.9rem',
      color: 'white',
      backgroundColor: "#6FAC22"
    },
    logo: {
      width: '40%',
      height: '40%'
    },
    banner: {
      width: '100%',
      // height: '40%'
    },
    footer: {
      width: '5%',
      height: '5%'
    },
    button_header: {
      marginTop: 20,
    },
    grid_header: {
      marginTop: 10,
    },
    copyright: {
      justifyContent: 'space-between'
    },
    multilineColor:{
      color:'red'
    },
    root: {
      background: "red"
    },
    input: {
      color: "white"
    },
    title: {
      color: 'rgb(0, 0, 1)',
      fontWeight: 'bold',
      fontSize: '1.75rem'
    },
    button: {
      fontSize: '0.875rem',
      color: 'white',
      background: 'linear-gradient(0deg, rgba(76,73,74,1) 24%, rgba(124,121,122,1) 68%, rgba(156,156,161,1) 100%)'
    },
    imageBackground: {
      height: '500', width: '800'
    },
    closeButton: {
      // position: 'absolute',
      right: theme.spacing(1),
      top: theme.spacing(1),
      color: theme.palette.grey[500],
    },
    rootTitle: {
      margin: 0,
      padding: theme.spacing(1),
    },
  }));

  export const backgroundStyles = makeStyles(theme => ({
    certificateBackground: {
      backgroundImage: `url(${process.env.PUBLIC_URL + '/images/Recurso1.png'})`,
      height: '500px',
      backgroundSize: 'contain',
      width: '690px',
      backgroundRepeat: 'no-repeat'
    },
  }))
